export default {
  // Header Elements:
  popupEl: document.querySelector('.header-pop-up-menu'),
  burgerEl: document.querySelector('.header-burger-btn'),
  closeBtnEl: document.querySelector('.pop-up-close-btn'),
  closeModalEl: document.querySelector('.pop-up-list'),
  closeModEl: document.querySelector('.pop-up-order-link'),
  openMenuEl: document.querySelector('.header-menu-list'),
  menuListEl: document.querySelector('.header-menu-btn'),
  headerSection: document.querySelector('.header'),
  //
  selectThemeElem: document.querySelector('#theme-select'),
  heroElem: document.querySelector('.hero-container'),
  bodyElem: document.querySelector('body'),
  // Footer Elements:
  contactForm: document.querySelector('.footer-form'),
  email: document.getElementById('user-email'),
  comments: document.getElementById('user-comment'),
  backdropEl: document.querySelector('.footer-backdrop'),
  modalEl: document.querySelector('.modal'),
  closeModalBtnEl: document.querySelector('.close-btn'),
  modalTitleEl: document.querySelector('.modal-title'),
  modalMessageEl: document.querySelector('.modal-message'),
  //Reviews
  reviewsList: document.querySelector('#reviews-list'),
  swiperBtns: document.querySelector('.navigation-buttons-reviews'),

  //Loader
  loader: document.querySelector('.load-container'),

  //To-the-top button
  upBtn: document.querySelector('.up-button'),

  toggleContainer: document.querySelector('.toggle-container'),
  toggle: document.querySelector('#theme-toggle'),
};
